<script>
export default {
    name: 'Utility',

    data() {
        return {
			SI_SYMBOL:["", "k", "M", "G", "T", "P", "E"]
		}
    },
    methods: {
        numberWithCommas(number) {
            if (number == undefined) {
                return;
            }
            return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        },

        numberSetPrecision(number, precision) {
            return (Math.round(number * 100000000000) / 100000000000).toFixed(precision);
        },

		abbreviateNumber(number){

			// what tier? (determines SI symbol)
			var tier = Math.log10(Math.abs(number)) / 3 | 0;

			// if zero, we don't need a suffix
			if(tier == 0) {
				return number;
			} 

			// get suffix and determine scale
			var suffix = this.SI_SYMBOL[tier];
			var scale = Math.pow(10, tier * 3);

			// scale the number
			var scaled = number / scale;

			var result_number = scaled.toFixed(1);

			if(this.numberLength(result_number)>3){
				result_number = Math.floor(result_number);
			}
			
			if(result_number.toString().indexOf(".")!=-1){
				//number is decimal check if decimal is 0
				var zero_check = result_number % 1;
				if(zero_check==0){
					//if decimal is 0 we don't need it for abbreviated number
					result_number = Math.round(result_number);
				}
			}

			// format number and add suffix
			return result_number + suffix;

		},

		numberLength(value) {
			if(Math.floor(value) === value){
				return value.toString().length
			}else{
				var number = value.toString().split(".")[0].length || 0;
				var floating =  value.toString().split(".")[1].length || 0;
				return number+floating;
			}
		},

        slugToTitle(slug) {

            var split = slug.split('-');
            var result = "";
            for (var i = 1; i < split.length; i++) {
                result += split[i][0].toUpperCase() + split[i].substring(1) + " ";
            }
            return result;
        },

        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }
}
</script>
